<template>
    <brick-settings-base
        v-if="show" 
        v-model="newName"
        :title="resource('JourneyComposer_BrickSettingsAudience_Title')"
        :canWrite="canWrite"
        :prompt="{
            title: resource('JourneyBuilder_AudienceSettings_Delete_Title'),
            body: resource('JourneyBuilder_AudienceSettings_Delete_Body')
        }"

        @save="saveSettings"
        @delete="$emit('delete')"       
        @hidden="$emit('hide')"
    >
    
        <settings-item icon="fas fa-user-friends">
            <template v-slot:label>
                <label :for="fieldName">{{fieldName}}</label>
            </template>
            <template v-slot:input>
                <v-select class="form-control"
                    v-model="selectedAudience"
                    label="name"
                    :options="audiences"
                    :disabled="!canWrite"
                    :clearable="false"

                    searchable
                    filterable
                >
                    <div slot="no-options" />
                </v-select>
            </template>
        </settings-item>

    </brick-settings-base>
</template>

<script>

import brickSettingsBase from '../BrickSettingsBase.vue';
import brickSettings from '../../../../Mixins/brick-settings';

export default {
    name: 'journey-brick-settings-audience',
    mixins: [brickSettings],
    components: {
        brickSettingsBase
    },
    created() {
        this.getAudiences((audiences) => {
            this.audiences = audiences;
        });
    },
    computed: {
        selectedAudience: {
            get(){
                return this.audiences.find(a => a.id === this.settings.audienceId)
            },
            set(value){
                this.settings.audienceId = value ? value.id : undefined;
            }
        }
    },
    data() {
        return {
            audiences: [],
            fieldName: this.resource('JourneyComposer_BrickSettingsAudience_Audience_DisplayName')
        };
    }
};
</script>

<style lang="scss" scoped>

</style>